import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { Lock, User as UserIcon, Eye, EyeSlash } from "@phosphor-icons/react";
import { toast } from "sonner";

const BRAND = "PINBOARD tameiakes.gr";

export default function LoginScreen() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) return;
    setLoading(true);
    setError("");
    try {
      await login(username.trim(), password);
      toast.success("ΕΠΙΤΥΧΗΣ ΕΙΣΟΔΟΣ");
    } catch (err) {
      const msg =
        err?.response?.data?.detail || err?.message || "Σφάλμα σύνδεσης";
      setError(typeof msg === "string" ? msg : "Σφάλμα");
      toast.error(typeof msg === "string" ? msg : "Σφάλμα");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6 board-bg"
      data-testid="login-screen"
    >
      <form
        onSubmit={submit}
        className="w-full max-w-sm glass rounded-3xl px-8 py-10 border border-white/40 shadow-xl"
      >
        <h1 className="font-caveat text-4xl font-bold text-ink leading-none">
          {BRAND}
        </h1>
        <p className="text-[10px] uppercase tracking-[0.25em] text-ink/55 font-bold mt-1 mb-7">
          ΕΙΣΟΔΟΣ ΔΙΑΧΕΙΡΙΣΤΗ
        </p>

        <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-ink/70 mb-1.5">
          ΟΝΟΜΑ ΧΡΗΣΤΗ
        </label>
        <div className="flex items-center gap-2 bg-white/70 border border-ink/15 rounded-xl px-3 mb-4 focus-within:border-ink/50 transition-colors">
          <UserIcon size={16} weight="bold" className="text-ink/60" />
          <input
            type="text"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="flex-1 bg-transparent py-2.5 outline-none font-arial text-sm"
            placeholder="username"
            data-testid="login-username"
            autoCapitalize="off"
            autoComplete="username"
          />
        </div>

        <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-ink/70 mb-1.5">
          ΚΩΔΙΚΟΣ
        </label>
        <div className="flex items-center gap-2 bg-white/70 border border-ink/15 rounded-xl px-3 mb-5 focus-within:border-ink/50 transition-colors">
          <Lock size={16} weight="bold" className="text-ink/60" />
          <input
            type={showPw ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="flex-1 bg-transparent py-2.5 outline-none font-arial text-sm"
            placeholder="••••••••"
            data-testid="login-password"
            autoComplete="current-password"
          />
          <button
            type="button"
            onClick={() => setShowPw((s) => !s)}
            className="text-ink/50 hover:text-ink p-1"
            tabIndex={-1}
            data-testid="login-toggle-pw"
          >
            {showPw ? <EyeSlash size={16} /> : <Eye size={16} />}
          </button>
        </div>

        {error && (
          <div
            className="text-[11px] font-bold uppercase tracking-wider text-red-700 bg-red-100/70 border border-red-300 rounded-lg px-3 py-2 mb-4"
            data-testid="login-error"
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading || !username.trim() || !password}
          data-testid="login-submit"
          className={`w-full py-3 rounded-full font-bold uppercase tracking-[0.2em] text-sm transition-all ${
            loading || !username.trim() || !password
              ? "bg-ink/30 text-white/70 cursor-not-allowed"
              : "bg-ink text-white hover:bg-ink/85 active:scale-95"
          }`}
        >
          {loading ? "ΣΥΝΔΕΣΗ..." : "ΕΙΣΟΔΟΣ"}
        </button>
      </form>
    </div>
  );
}
